import * as Yup from 'yup'

export const PotentialInfluencerSignupDeSchema = Yup.object().shape({
    name: Yup.string()
    .required('Erforderlich'),
    email: Yup.string()
    .matches(/^[\w-\.]+@[\w-\.]+\.[a-zA-Z]{2,}$/, "Ungültige E-Mail-Adresse")
    .email('Invalid email')
    .required('Erforderlich'),
    instagram_username: Yup.string()
    .matches(/^[^@]/, 'Bitte schließe das @ nicht ein')
    .matches(/^[\w\.]+$/, 'Bitte gib nur den Benutzernamen ein, nicht die vollständige URL')
    .test('at-least-one-platform', 'Bitte gib mindestens einen Social-Media-Benutzernamen an', function(value) {
      const { tiktok_username, youtube_username, linkedin_username } = this.parent;
      const filledFields = [value, tiktok_username, youtube_username, linkedin_username].filter(Boolean).length;
      return filledFields >= 1;
    }),
    tiktok_username: Yup.string()
    .matches(/^[^@]/, 'Bitte schließe das @ nicht ein')
    .matches(/^[\w\.]+$/, 'Bitte gib nur den Benutzernamen ein, nicht die vollständige URL')
    .test('at-least-one-platform', 'Bitte gib mindestens einen Social-Media-Benutzernamen an', function(value) {
      const { instagram_username, youtube_username, linkedin_username } = this.parent;
      const filledFields = [instagram_username, value, youtube_username, linkedin_username].filter(Boolean).length;
      return filledFields >= 1;
    }),
    youtube_username: Yup.string()
    .matches(/^[^@]/, 'Bitte schließe das @ nicht ein')
    .matches(/^[\w\.]+$/, 'Bitte gib nur den Benutzernamen ein, nicht die vollständige URL')
    .test('at-least-one-platform', 'Bitte gib mindestens einen Social-Media-Benutzernamen an', function(value) {
      const { instagram_username, tiktok_username, linkedin_username } = this.parent;
      const filledFields = [instagram_username, tiktok_username, value, linkedin_username].filter(Boolean).length;
      return filledFields >= 1;
    }),
    linkedin_username: Yup.string()
    .matches(/^[^@]/, 'Bitte schließe das @ nicht ein')
    .matches(/^[\w\.]+$/, 'Bitte gib nur den Benutzernamen ein, ohne Leerzeichen und ohne die vollständige URL.')
    .test('at-least-one-platform', 'Bitte gib mindestens einen Social-Media-Benutzernamen an', function(value) {
      const { instagram_username, tiktok_username, youtube_username } = this.parent;
      const filledFields = [instagram_username, tiktok_username, youtube_username, value].filter(Boolean).length;
      return filledFields >= 1;
    }),
    legal_age_accepted: Yup.boolean()
    .oneOf([true], 'Du musst bestätigen, dass du volljährig bist.')
    .required('Erforderlich'),
    privacy_policy_accepted: Yup.boolean()
    .oneOf([true], 'Bestätige, dass du die Datenschutzbestimmungen lesen hast.')
    .required('Erforderlich'),
    tc_accepted: Yup.boolean()
    .oneOf([true], 'Du musst die Nutzungsbedingungen bestätigen')
    .required('Erforderlich'),
    newsletter_opt_in: Yup.boolean()
});
